/**
 * category-tabs-sticky.js
 *
 * Додає клас .is-stuck секції .shopify-section.category-tabs,
 * коли вона зафіксована (position: sticky) вгорі екрана під час скролу.
 * Клас можна використати в CSS, щоб показати тінь тільки в "приклеєному" стані.
 *
 * CSS (додати поруч з існуючими стилями):
 *
 * .shopify-section.category-tabs.is-stuck {
 *   box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.10);
 * }
 */
(function () {
  'use strict';

  function initCategoryTabsSticky() {
    var section = document.querySelector('.shopify-section.category-tabs');
    if (!section) return;

    // IntersectionObserver не підтримується — просто нічого не додаємо
    if (!('IntersectionObserver' in window)) return;

    // Створюємо "вартового" — невидимий елемент прямо перед секцією.
    // Коли він виходить за межі вʼюпорту (скролиться вгору за екран),
    // це означає, що секція вже "приклеїлась" до шапки.
    var sentinel = document.createElement('div');
    sentinel.className = 'category-tabs-sticky-sentinel';
    sentinel.style.cssText = 'position:relative;height:1px;width:100%;pointer-events:none;';
    section.parentNode.insertBefore(sentinel, section);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // intersectionRatio < 1 означає, що sentinel вже не повністю
          // видимий (почав ховатись за верхній край) — секція зафіксована.
          section.classList.toggle('is-stuck', entry.intersectionRatio < 1);
        });
      },
      { threshold: [1] }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryTabsSticky);
  } else {
    initCategoryTabsSticky();
  }
})();